module.exports = __webpack_public_path__ + "static/city-9d46dde4067fa51b536a052f531e22af.jpg";